/* eslint-disable camelcase */
import get from 'lodash/get';
import { stringify } from 'query-string';

const WebRoot = get(window, 'beagly.webRoot', '');

// NOTE: used in dev
// const WebRoot = 'https://staging.beag.ly';
const ApiRoot = `${WebRoot}/api/internal`;

function authViaGet(token, url) {
  const encoded = encodeURIComponent(url);
  return `${WebRoot}/start?token=${token}&continue_url=${encoded}`;
}

export const getAvailableSearchOperandsUrl = () => `${ApiRoot}/available_search_operands`;

export function getCurrentUrl() {
  const { origin, pathname } = window.location;
  return `${origin}${pathname}`;
}

export const getGoogleDocsExportUrl = (surveyId, user) =>
  `${WebRoot}/start_google_docs_export?survey_id=${surveyId}&redirect_url=${getCurrentUrl()}&email=${
    user.email
  }&token=${user.token}`;

export const getGoogleSheetsExportUrl = (survey_ids, user, filters = {}) => {
  const ids = stringify({ survey_ids, ...filters }, { arrayFormat: 'bracket' });
  return `${WebRoot}/start_google_sheets_export?${ids}&redirect_url=${getCurrentUrl()}&email=${
    user.email
  }&token=${user.token}`;
};

export const updateGoogleSheetsExportUrl = (survey_ids, user, filters = {}) => {
  const ids = stringify({ survey_ids, ...filters }, { arrayFormat: 'bracket' });
  return `${WebRoot}/update_google_sheets_export?${ids}&redirect_url=${getCurrentUrl()}&email=${
    user.email
  }&token=${user.token}`;
};

export const getEnabledFeaturesUrl = () => `${ApiRoot}/organization_features`;

export const getBackgroundJobsStatusUrl = () => `${ApiRoot}/background_job_status`;
export const getBackgroundJobsDetailsUrl = (jobId) =>
  `${ApiRoot}/organization_background_job/${jobId}`;
export const getBackgroundJobsStopUrl = () => `${ApiRoot}/stop_background_job`;

export const getBlacklistUrl = () => `${ApiRoot}/blacklisted_items`;
export const getBlacklistExportUrl = () => `${ApiRoot}/blacklisted_items/export`;
export const getBlacklistPhoneExportUrl = () => `${ApiRoot}/blacklisted_items/export_phone_numbers`;
export const getBlacklistItemUrl = (id) => `${ApiRoot}/blacklisted_items/${id}`;

export const getCampaignsUrl = () => `${ApiRoot}/campaigns`;
export const getAnonymousCampaignsUrl = () => `${ApiRoot}/anonymous_campaigns`;
export const getTextCampaignsUrl = () => `${ApiRoot}/text_campaigns`;
export const getCampaignsItemUrl = (campaignId) => `${ApiRoot}/campaigns/${campaignId}`;
export const getAnonymousCampaignsItemUrl = (campaignId) =>
  `${ApiRoot}/anonymous_campaigns/${campaignId}`;
export const getTextCampaignsItemUrl = (campaignId) => `${ApiRoot}/text_campaigns/${campaignId}`;
export const getCampaignsParticipantsUrl = () => `${ApiRoot}/campaign_participants`;
export const getCampaignsParticipantsExportUrl = () => `${ApiRoot}/export_campaign_participants`;
export const getCampaignsParticipantUrl = (participantId) =>
  `${getCampaignsParticipantsUrl()}/${participantId}`;
export const getCampaignParticipantsCreateWebhookUrl = () =>
  `${getCampaignsParticipantsUrl()}/create_webhook`;
export const getCampaignParticipantsDeleteWebhookUrl = () =>
  `${getCampaignsParticipantsUrl()}/delete_webhook`;
export const getCampaignMetricsDataUrl = () => `${ApiRoot}/text_campaign_metrics_data`;
export const getCurrenciesUrl = () => `${ApiRoot}/currencies`;

export const getCheckUserForEmailUrl = () => `${ApiRoot}/check_user_for_email`;

export const getFraudDetectionSettingsUrl = () => `${ApiRoot}/fraud_detection_settings`;
export const getFraudDetectionSettingsItemUrl = (id) => `${ApiRoot}/fraud_detection_settings/${id}`;

export const getFacebookAuthUrl = () => `${ApiRoot}/facebook_auth_url`;
export const getFacebookDisconnectUrl = () => `${ApiRoot}/organization_remove_facebook`;

export const getGiftbitAuthUrl = () => `${ApiRoot}/giftbit_auth_url`;
export const getGiftbitDisconnectUrl = () => `${ApiRoot}/organization_remove_giftbit`;

export const getMessageTemplatesUrl = () => `${ApiRoot}/message_templates`;
export const getMessageTemplateUrl = (messageTemplateId) =>
  `${getMessageTemplatesUrl()}/${messageTemplateId}`;
export const getMessageTemplatesSendUrl = (messageTemplateId) =>
  `${getMessageTemplateUrl(messageTemplateId)}/send`;

export const getLoginUrl = () => `${ApiRoot}/session/login`;
export const getResetPasswordUrl = () => `${ApiRoot}/session/reset_password`;
export const getOrganizationsUrl = () => `${ApiRoot}/organizations`;
export const getOrganizationsItemUrl = (organizationId) =>
  `${getOrganizationsUrl()}/${organizationId}`;
export const getOrganizationsRemoveBgImageUrl = () => `${ApiRoot}/organization_remove_bg_image`;
export const getOrganizationsRemoveLogoUrl = () => `${ApiRoot}/organization_remove_logo`;
export const getOrganiztionBackgroundJobsListUrl = () => `${ApiRoot}/organization_background_jobs`;
export const getOrganiztionBackgroundJobsCountUrl = () =>
  `${ApiRoot}/organization_background_jobs_count`;
export const getOrganiztionBackgroundJobDetailsUrl = (job_id) =>
  `${ApiRoot}/organization_background_job/${job_id}`;
export const getBackgroundJobsUpdatedInOrganizationUrl = () =>
  `${ApiRoot}/organization_background_jobs_updates`;
export const getOrganizationsCreateServiceUrl = () => `${ApiRoot}/organization_sms_service_create`;
export const getOrganizationsFetchTwilioDataUrl = () => `${ApiRoot}/organization_fetch_twilio_data`;

export const getMembershipsCurrentUrl = () => `${ApiRoot}/current_user_memberships`;
export const getMembershipsByUserUrl = (userId) => `${ApiRoot}/user_memberships/${userId}`;
export const getMembershipsUrl = () => `${ApiRoot}/memberships`;
export const getAllMembershipsUrl = () => `${ApiRoot}/all_memberships`;
export const getMembershipsItemUrl = (membershipId) => `${ApiRoot}/memberships/${membershipId}`;
export const getSurveysUrl = () => `${ApiRoot}/surveys`;
export const getSurveysRecentUrl = () => `${ApiRoot}/surveys_recent`;
export const getResearchersUrl = () => `${ApiRoot}/researchers`;
export const getReverseLookupUrl = () => `${ApiRoot}/reverse_survey_lookup`;

export const getAnswersUrl = () => `${ApiRoot}/answers`;
export const getAnswersUpdateUrl = (answerId) => `${ApiRoot}/answers/${answerId}`;

export const getConditionsUrl = () => `${ApiRoot}/conditions`;
export const getConditionsItemUrl = (conditionId) => `${ApiRoot}/conditions/${conditionId}`;

export const getDataTypesUrl = () => `${ApiRoot}/data_types`;
export const getGiftbitConnectedRewardsUrl = () =>
  `${ApiRoot}/giftbit_rewards_with_short_term_locks`;
export const getGiftbitRegionsUrl = () => `${ApiRoot}/giftbit_regions`;
export const getGiftbitRewardsUrl = () => `${ApiRoot}/giftbit_rewards`;
export const getGiftbitStatusUrl = () => `${ApiRoot}/giftbit_status`;

export const getGiftbitAwailableRewardsUrl = () => `${ApiRoot}/available_giftbit_rewards`;
export const getGiftbitAwailableRewardsItemUrl = (rewardId) =>
  `${ApiRoot}/available_giftbit_rewards/${rewardId}`;

export const getElementsUrl = () => `${ApiRoot}/elements`;
export const getElementsItemUrl = (elementId) => `${ApiRoot}/elements/${elementId}`;
export const getElementTagsUrl = () => `${ApiRoot}/element_tags`;
export const getElementTagsItemUrl = (tagId) => `${ApiRoot}/element_tags/${tagId}`;
export const getElementTypesUrl = () => `${ApiRoot}/types`;

export const getImmediateRewardUrl = () => `${ApiRoot}/issue_immediate_reward`;

export const getLayoutsUrl = () => `${ApiRoot}/page_layouts`;
export const getLayoutsItemUrl = (layoutId) => `${ApiRoot}/page_layouts/${layoutId}`;

export const getMailchimpGroupsUrl = () => `${ApiRoot}/mailchimp_groups`;
export const getMailchimpListsUrl = () => `${ApiRoot}/mailchimp_lists`;
export const getMailchimpSegmentsUrl = () => `${ApiRoot}/mailchimp_segments`;
export const getMailchimpListDownloadUrl = () => `${ApiRoot}/mailchimp_list_download`;
export const getMailchimpListUploadUrl = () => `${ApiRoot}/mailchimp_list_upload`;

export const getPagesUrl = () => `${ApiRoot}/pages`;
export const getPagesCopyUrl = (pageId) => `${ApiRoot}/pages/${pageId}/copy`;
export const getPagesItemUrl = (pageId) => `${ApiRoot}/pages/${pageId}`;
export const getPagesSortUrl = () => `${ApiRoot}/pages/position_changes`;

export const getParticipantsUrl = () => `${ApiRoot}/participants`;
export const getParticipantsAddToGroupUrl = () => `${ApiRoot}/participant_group_memberships`;
export const getParticipantsDetailUrl = () => `${ApiRoot}/participant_detail`;
export const getParticipantGroupsUrl = () => `${ApiRoot}/participant_groups`;
export const getParticipantGroupsItemUrl = (groupId) => `${ApiRoot}/participant_groups/${groupId}`;
export const getParticipantOperatorsUrl = () => `${ApiRoot}/participant_operators`;
export const getParticipantSearchConditionsUrl = () => `${ApiRoot}/participant_search_conditions`;
export const getParticipantSearchConditionsItemUrl = (id) =>
  `${ApiRoot}/participant_search_conditions/${id}`;
export const getParticipantSearchRulesUrl = () => `${ApiRoot}/participant_search_rules`;
export const getParticipantSearchRulesItemUrl = (id) => `${ApiRoot}/participant_search_rules/${id}`;
export const getParticipantsExportUrl = () => `${ApiRoot}/export_participants`;

export const getParticipantImpressionUrl = () => `${ApiRoot}/participant_impression`;
export const getParticipantResetUrl = () => `${ApiRoot}/reset_participant_auth`;
export const getParticipantEmailUrl = () => `${ApiRoot}/set_participant_email`;
export const getParticipantOAuthResetUrl = () => `${ApiRoot}/reset_participant_auth`;

export const getAnalyticsUrl = () => `${ApiRoot}/analytics`;

export const getReportDataUrl = () => `${ApiRoot}/report_data`;
export const getReportOptionsUrl = () => `${ApiRoot}/report_options`;
export const getGiftbitRewardStatusUrl = () => `${ApiRoot}/update_and_get_giftbit_reward_status`;

export const getResults = () => `${ApiRoot}/results`;
export const getResultInitUrl = () => `${ApiRoot}/results`;
export const getResultDetailsUrl = () => `${ApiRoot}/result_details`;
export const getResultItemUrl = (surveyId) => `${ApiRoot}/results/${surveyId}`;
export const getResultExportUrl = () => `${ApiRoot}/results/export`;
export const getResultFinishUrl = () => `${ApiRoot}/results/finish`;
export const getResultRedirectedUrl = () => `${ApiRoot}/results/redirect`;
export const getCreateDirectResponseInvitationUrl = () =>
  `${ApiRoot}/result_details/create_direct_response_invitation`;

export const getRewardCodeProvidersUrl = () => `${ApiRoot}/reward_code_providers`;
export const getRewardCodesUrl = () => `${ApiRoot}/rewards`;

export const getRulesUrl = () => `${ApiRoot}/rules`;
export const getRulesItemUrl = (ruleId) => `${ApiRoot}/rules/${ruleId}`;

export const getSurveysItemUrl = (surveyId) => `${ApiRoot}/surveys/${surveyId}`;
export const getSurveysActiveUrl = (surveyId) => `${ApiRoot}/active_surveys/${surveyId}`;
export const getSurveyHashUrl = (surveyId) => `${ApiRoot}/surveys/${surveyId}/dirty_hash`;
export const getSurveysByTagId = (tagId) => `${ApiRoot}/tagged_surveys/${tagId}`;

export const getSurveysHistoryUrl = (surveyId) => `${ApiRoot}/surveys/${surveyId}/history`;
export const getSurveysVersionsUrl = () => `${ApiRoot}/survey_versions/`;
export const getSurveysCopyUrl = (surveyId) => `${ApiRoot}/surveys/${surveyId}/copy`;
export const getSurveysMoveUrl = (surveyId) => `${ApiRoot}/surveys/${surveyId}/move`;
export const getSystemSettingsUrl = () => `${ApiRoot}/system_settings`;
export const getSystemSettingsItemUrl = (id) => `${ApiRoot}/system_settings/${id}`;
export const getOrganizationTagsUrl = () => `${ApiRoot}/system_tags`;
export const getOrganizationTagsItemUrl = (id) => `${ApiRoot}/system_tags/${id}`;

export const getTimezonexUrl = () => `${ApiRoot}/timezones`;

export const getUsersUrl = () => `${ApiRoot}/users`;
export const getUsersItemUrl = (userId) => `${ApiRoot}/users/${userId}`;
export const getUsersSetPasswordUrl = () => `${ApiRoot}/set_user_password`;
export const getUsersRecoverUrl = () => `${ApiRoot}/recover_user`;

export const getUserRoleUrl = () => `${ApiRoot}/update_user_role`;
export const getUploadsUrl = () => `${ApiRoot}/uploads`;
export const getUploadsItemUrl = (id) => `${ApiRoot}/uploads/${id}`;
export const getParticipantUploadsUrl = () => `${ApiRoot}/participant_uploads`;

export const getResultsPageUrl = (token, surveyId) =>
  authViaGet(token, `${WebRoot}/results?survey_id=${surveyId}`);

export const getRewardsUrl = (token, surveyId) =>
  authViaGet(token, `${WebRoot}/rewards?survey_id=${surveyId}`);

export const getOAuthUrl = (provider, token) => {
  const patchedProvider = provider === 'google' ? 'google_oauth2' : provider;
  return `${WebRoot}/users/auth/${patchedProvider}?result_token=${token}`;
};

export const assetsBase = 'https://d2lhmk0wz60r3x.cloudfront.net';
export const assets = {
  browserNotSupportedImage: `${assetsBase}/assets/browser-not-supported.jpg`,
  notFoundImage: `${assetsBase}/assets/404.jpg`,
  transparentLogo: `${assetsBase}/home/logo-transparent4.png`,
};
